import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zoiizyfqeaiworijqqyg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpvaWl6eWZxZWFpd29yaWpxcXlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3NTM2ODUsImV4cCI6MjA4ODMyOTY4NX0.GFFExtFOE7jeP3Wd5tOhnPiA6QBgxVTtfa-FDPA3Kfo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
